// extracted by mini-css-extract-plugin
export default {"heading":"OqyamR"};